import React from "react";
import { Container } from "react-grid-system";

// STYLES
import styled from "styled-components";

// IMAGES
import Wine from "../../images/wine.png";
import Ahresp_1x from "../../images/logo-ahresp.png";
import Turismo_1x from "../../images/logo-turismo-portugal.png";
import Economia_1x from "../../images/ministerio-economia.png";

export default class Sponsors extends React.Component {
  render() {
    let { t } = this.props;
    return (
      <div>
        <Container fluid style={{ paddingLeft: "0", paddingRight: "0" }}>
          <ParallaxImage style={{ backgroundImage: "url(" + Wine + ")" }}>
            <TextBox>
              <h5>
                {t(
                  "Temos o papel de contribuir diretamente para o reconhecimento internacional da gastronomia portuguesa, criando os meios para que esta possa ser saboreada em todos os cantos do mundo e potenciando Portugal como um destino turístico e gastronómico"
                )}
                .
              </h5>
            </TextBox>
          </ParallaxImage>
        </Container>
        <Container
          fluid
          style={{ paddingLeft: "0", paddingRight: "0" }}
          className="backgroundColor"
        >
          <Container>
            <SponsorsList>
              <div>
                <a
                  href="http://www.ahresp.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SponsorsImg src={Ahresp_1x} alt={t("AHRESP")} />
                </a>
              </div>
              <div>
                <a
                  href="https://www.sgeconomia.gov.pt/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SponsorsImg
                    src={Economia_1x}
                    alt="RÉPUBLICA PORTUGUESA ECONOMIA"
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://www.turismodeportugal.pt/pt/Paginas/homepage.aspx"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SponsorsImg
                    src={Turismo_1x}
                    alt={t("TURISMO DE PORTUGAL")}
                  />
                </a>
              </div>
            </SponsorsList>
          </Container>
        </Container>
      </div>
    );
  }
}

const ParallaxImage = styled.div`
  width: 100%;
  height: 500px;
  background-position: center;
  background-size: cover;
  position: relative;

  @media screen and (max-width: 875px) {
    height: 300px;
  }
`;
const TextBox = styled.div`
  width: 840px;
  height: 245px;
  background-color: #ffffff;
  box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.1);
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  padding-left: 30px;
  padding-right: 30px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: -122px;
  z-index: 2;

  h5 {
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    opacity: 0.8;
    line-height: 150%;
    color: hsl(0, 0%, 17%);
    font-family: "PT Sans";
  }

  @media screen and (max-width: 875px) {
    width: calc(100% - 90px);
    margin-left: 15px;
    margin-right: 15px;
  }

  @media screen and (max-width: 530px) {
    h5 {
      font-size: 16px;
    }
  }
`;
const SponsorsList = styled.div`
  padding-top: 230px;
  padding-bottom: 7%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;

  @media screen and (max-width: 992px) {
    display: block;
    text-align: center;
    padding-top: 180px;
  }
`;
const SponsorsImg = styled.img`
  @media screen and (max-width: 992px) {
    margin-bottom: 50px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/sponsors/sponsors.component.js